import { styled } from '@mui/material';

const ButtonBox = styled('div')(({ theme }) => {
  return {
    display: 'flex',
    flexDirection: 'column',
    '& .MuiButton-root:nth-of-type(2)': {
      marginLeft: '0px',
      marginTop: '12px',
    },
    [theme.breakpoints.up('sm')]: {
      flexDirection: 'row',
      '& .MuiButton-root:nth-of-type(2)': {
        marginLeft: '16px',
        marginTop: '0px',
      },
    },
  };
});

export default ButtonBox;
